import type { Icon } from 'types'

export const ICON_UPLOAD_INIT = 'ICON_UPLOAD_INIT'
export const ICON_UPLOAD_START = 'ICON_UPLOAD_START'
export const ICON_UPLOAD_SUCCESS = 'ICON_UPLOAD_SUCCESS'
export const ICON_UPLOAD_ERROR = 'ICON_UPLOADERROR'

export const actionTypes = {
  ICON_UPLOAD_INIT,
  ICON_UPLOAD_START,
  ICON_UPLOAD_SUCCESS,
  ICON_UPLOAD_ERROR,
}

export function uploadIconInit() {
  return {
    type: ICON_UPLOAD_INIT,
  }
}

export function uploadIconStart(name: string, blob: string) {
  return {
    type: ICON_UPLOAD_START,
    payload: {
      blob,
      name,
    },
  }
}

export function uploadIconSuccess(icon: Icon) {
  return {
    type: ICON_UPLOAD_SUCCESS,
    payload: {
      icon,
    },
  }
}

export function uploadIconError(error: Error) {
  return {
    type: ICON_UPLOAD_ERROR,
    payload: {
      error,
    },
  }
}

export const actions = {
  start: uploadIconStart,
  success: uploadIconSuccess,
  error: uploadIconError,
}

export function getUploadStatus(state) {
  return state.icons.creation.status
}

export function getUploadError(state) {
  return state.icons.creation.error
}

export function getIcon(state) {
  return state.icons.creation.icon
}

const initialState = {
  status: 'initialized',
}

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case ICON_UPLOAD_INIT:
      return initialState
    case ICON_UPLOAD_START:
      const { name, blob } = payload
      return {
        status: 'uploading',
        name,
        blob,
      }
    case ICON_UPLOAD_SUCCESS:
      const { icon } = payload
      return {
        ...state,
        status: 'success',
        icon,
      }
    case ICON_UPLOAD_ERROR:
      const { error } = payload
      return {
        status: 'error',
        error,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/icons/creation.js